import urlPdvend from "./url/pdvend";
import urlMhi from "./url/mhi";

import whitelabelPdvend from "./whitelabel/pdvend";
import whitelabelMhi from "./whitelabel/mhi";

import formLabelsPdvend from "./form-labels/pdvend";
import formLabelsMhi from "./form-labels/mhi";

const enumCompanies = {
  PDVEND: {
    url: urlPdvend,
    whitelabel: whitelabelPdvend,
    formLabels: formLabelsPdvend
  },
  MHI: {
    url: urlMhi,
    whitelabel: whitelabelMhi,
    formLabels: formLabelsMhi
  }
};

const enumWhitelabel = enumCompanies[process.env.REACT_APP_WHITELABEL_NAME];

export default enumWhitelabel;



// WEBPACK FOOTER //
// ./src/assets/enum/index.js